import styled from "styled-components";

export const ContainerHeader = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  width: 100%;
  height: 80px;
  background-color: #0a5190;
  z-index: 2;   
`;

export const BodyHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 10% 0px 10%;
  width: 100%;
  height: 80px;
  z-index: 2;
`;

export const ButtonLogountHeader = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80px;
  color: white;
  padding: 0px 10px 0px 10px;
  background-color: transparent;
  border: 1.44624px solid #FFFFFF;
  border-radius: 8px;
  cursor: pointer;  
`;

export const LogoHeader = styled.img`
height: 120px;
`;
